import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateEmojiMutation = createMutationHook(MembershipsCreatorApiClient.updateEmoji, {
  mutationKey: ['updateEmoji'],
})
